<template>
  <div class="content">
    <s-location mypage title="질의응답"/>

      <table class="tbl01 view01">
				<thead>
				  <tr>
				    <td class="title m_pl0">
              <span v-if="sitem.KIND">
                [ {{ sitem.KIND }} ]
              </span>
              <span v-html="sitem.TITL" />
              <div class="td_date">
                {{ sitem.INCMGDT | moment("YYYY.MM.DD") }}
              </div>
            </td>
				  </tr>
          <tr>
            <td  class="al_l"><div v-html="sitem.CONT" /></td>
          </tr>
          <tr>
            <td class="al_l">
              <span v-if="sitem.ATTACHID" class="right">
                <!-- <a :href="`${ $api }/file/notice/${ sitem.attachid }`"><i-btn btn01>다운로드</i-btn></a> -->
                <a :href="`${ $api }/file/qna/${ sitem.ATTACHID }?view=1`" target="_blank"><i-btn class="btn xs black02">첨부파일 보기</i-btn></a>
              </span>
            </td>
          </tr>
          <tr>
            <td class="al_l"   v-if="sitem.ANSWYN=='Y'"><div v-html="sitem.ANSW" /></td>
            <td style="center" v-else >답변이 등록되지 않았습니다.</td>
          </tr>
				</thead>
      </table>
        <div class="btn_group">
          <!--
          <div class="left">
            <a @click="updItem" class="btn">수정</a>
            <a @click="delItem" class="btn">삭제</a>
          </div>
          -->
          <div class="right">
            <a @click="$router.go(-1)" class="btn black01">목록</a>
          </div>
        </div>
  </div>
</template>

<script>
let ui
export default {
  data() {
    return {
      sitem : {}
    }
  },
  created() {
    ui = this.$ui
    this.getData()
  },

  methods: {

    getData() {

      ui.httpGet(
        '/mypage/qna_view',
        {
            SEQ    : this.$route.query.seq
        },
        ret => this.sitem = ret.data.item,
        )

    },

    // updItem(){
    //   this.$router.push({path: '/mypage/qna_form', query: { seq: this.sitem.SEQ }})
    // },

//     delItem(){

// /*       ui.confirm('삭제하시겠습니까 ?', "삭제완료")
//         .then(r => r && this.itemUpdate()) */

//       ui.httpPost(
//         '/mypage/qna_delete',
//         this.sitem,
//         ret => this.$router.push({path: '/mypage/qna'}),
//         )

//     },

  },
}
</script>